// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","layout":"App_layout__UNCUu"};